module.exports = __webpack_public_path__ + "static/media/SarahSwitek_04_BodySensations_25.4b9af78e.mp3";